import React, { useEffect, useState } from 'react';
import { StatusFormSetting } from '../../../AssetDetails/AssetTabs';
import '../../../../Forms.scss'
import IOTCommunicationModal from '../../../common/Modal/IOTCommunicationModal';

interface FieldState {
    [key: string]: string;
}

type SetPageFunction = React.Dispatch<React.SetStateAction<{ [key: string]: FieldState; }>>;
type SetTabPageFunction = React.Dispatch<React.SetStateAction<string>>
type SetChangeFieldFunction = React.Dispatch<React.SetStateAction<{
    [formName: string]: Set<string>;
}>>

interface GenericFormProps {
    formState: { [key: string]: FieldState };
    setFormState: SetPageFunction;
    setTabDivHeight: SetTabPageFunction;
    GenericFormData: StatusFormSetting[] | undefined;
    changedFields: { [formName: string]: Set<string> };
    setChangedFields: SetChangeFieldFunction;
    formNames: string;
    isToggle: boolean;
}
interface InitialValues {
    [formName: string]: {
        [fieldName: string]: string;
    };
}


const GenericFormTablet: React.FC<GenericFormProps> = ({ formNames, formState, setFormState, setTabDivHeight, GenericFormData, changedFields, setChangedFields, isToggle }) => {
    const [initialValues, setInitialValues] = useState<{ [formName: string]: { [fieldName: string]: string } }>({});
    const FormName = formNames
    const [isIotModalOpen, setIsIotModalOpen] = useState(false);


    useEffect(() => {
        setTabDivHeight("700px");
    }, []);

    useEffect(() => {
        // Initialize initial values when the component mounts or when form data is initialized
        const initialValues: InitialValues = {};
        // Initialize initial values for each form and field
        // Assuming formState has been initialized with initial form data
        Object.keys(formState).forEach(formName => {
            initialValues[formName] = {};
            Object.keys(formState[formName]).forEach(fieldName => {
                initialValues[formName][fieldName] = formState[formName][fieldName];
            });
        });
        setInitialValues(initialValues);
        setChangedFields({})
    }, [formNames, isToggle]);

    // Handle input change for a specific field in a specific form
    const handleInputChange = (formName: string, fieldName: string, value: string) => {

        setFormState((prevFormState) => ({
            ...prevFormState,
            [formName]: {
                ...prevFormState[formName],
                [fieldName]: value,
            },
        }));

        // setChangedFields((prevChangedFields) => ({
        //   ...prevChangedFields,
        //   [formName]: new Set<string>([...(prevChangedFields[formName] || []), fieldName]),
        // }));

        // Show modal when IoTHubCommunication = "0"
        if (fieldName === "IoTHubCommunication" && value === "0") {
            setIsIotModalOpen(true);
        }
    };

    // Function to identify change in field value
    const handleFieldChange = (formName: string, fieldName: string, newValue: string) => {
        const initialValue = initialValues[formName]?.[fieldName];
        if (initialValue !== newValue) {
            setChangedFields((prevChangedFields) => ({
                ...prevChangedFields,
                [formName]: new Set<string>([...(prevChangedFields[formName] || []), fieldName]),
            }));
        } else if (initialValue === newValue) {
            setChangedFields((prevChangedFields) => {
                const updatedFields = new Set<string>(prevChangedFields[formName] || []);
                updatedFields.delete(fieldName); // Remove the field name if the value reverts back to the initial value
                return {
                    ...prevChangedFields,
                    [formName]: updatedFields,
                };
            });
        }
    };

    return (
        <div>
            {/* Plunger Form */}
            <div style={{ display: 'flex', flexWrap: 'wrap', columnGap: '10px', rowGap: '6px', justifyContent: 'flex-start' }}>
                {GenericFormData?.map(({ id, value, name, label, type, options, enable, description, unit, isGrayedOut }) => (
                    enable ?
                        <div key={id} className='io-container' style={{ flex: '1 1 20%', minWidth: '150px' }}>
                            {enable && (
                                <div className="tooltip-container">
                                    <label
                                        style={{ display: 'block', marginBottom: '2px', marginLeft: "3px" }}
                                    >
                                        {label}
                                    </label>
                                    {description && <span className="tooltip-text">{description}</span>}
                                </div>
                            )}
                            {type !== "dropdown" ?
                                <div className="relative w-full">
                                    {/* Unit Text - Positioned inside the input */}
                                    {unit && (
                                        <div
                                            className="absolute inset-y-0 right-2 flex items-center pointer-events-none input-with-unit"
                                            style={{
                                                color: "var(--Primary-Indigo-500, #0094BD)",
                                                fontSize: "16px",
                                            }}
                                        >
                                            | {unit}
                                        </div>
                                    )}
                                    <input
                                        type={name?.toLocaleLowerCase() === "iccid" || name?.toLocaleLowerCase() === "serialnumber" ? "string" : "number"}
                                        value={formState[FormName] ? formState[FormName][name] : value}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            handleInputChange(FormName, name, newValue);
                                            handleFieldChange(FormName, name, newValue);
                                        }}
                                        style={{ display: enable ? "" : "none", padding: "6px", color: 'white', borderRadius: '8px', textAlign: 'right', backgroundColor: changedFields[FormName]?.has(name) ? "rgb(208 196 64)" : "rgb(5 17 35)", width: "100%", paddingRight: unit ? "5rem" : "6px" }}
                                        placeholder={label}
                                        disabled={name?.toLocaleLowerCase() === "iccid" || name?.toLocaleLowerCase() === "serialnumber" ? true : false}
                                    />
                                </div> : <select
                                    value={formState[FormName] ? formState[FormName][name] : value}
                                    onChange={(e) => {
                                        const newValue = e.target.value;
                                        handleInputChange(FormName, name, newValue);
                                        handleFieldChange(FormName, name, newValue);
                                    }}
                                    style={{
                                        display: enable ? "" : "none", padding: "6px", color: 'white', borderRadius: '8px', textAlign: 'left', backgroundColor: changedFields[FormName]?.has(name)
                                            ? "rgb(208 196 64)"
                                            : (isGrayedOut)
                                                ? "#4A5463"
                                                : "rgb(5 17 35)", width: "100%"
                                    }}
                                    disabled={
                                        name === "IoTHubCommunication"
                                            ? isGrayedOut
                                            : name?.toLowerCase() === "iccid"
                                    }
                                >
                                    {options?.map((option: any) => (
                                        <option key={option.value} value={option.value}>
                                            {option.text}
                                        </option>
                                    ))}
                                </select>}
                        </div> : <></>
                ))}
            </div>
            <IOTCommunicationModal
                isOpen={isIotModalOpen}
                message={
                    <>
                        IoT Hub Communication will be disabled.<br />
                        The device will stop sending data to the cloud.<br />
                        Re-enabling is possible only from the local webpage.
                    </>
                }
                setIsValveModalOpen={setIsIotModalOpen}
            />
        </div>

    );
};

export default GenericFormTablet;
